<template>
  <div>
    <transition-group class="notification-panel" tag="div" name="notification-panel">
      <div
        class="notification-panel__item"
        v-for="notification in notifications"
        :key="notification.ID"
      >
        <span
          class="notification-panel__item-close"
          @click="() => deleteItemNotification(notification.ID)"
        >
          <i class="mdi mdi-close"></i>
        </span>
        <div class="notification-panel__item-content" @click="() => onClickPanel(notification)">
          <div class="notification-panel__item-icon">
            <i class="mdi mdi-check-circle"></i>
          </div>
          <div class="notification-panel__item-text">
            <span class="notification__title">
              {{ notification.Title }}
            </span>
            <span class="notification__message">
              {{ notification.Message }}
            </span>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'NotificationPanel',
  data() {
    return {
      notifications: [],
    };
  },
  mounted() {
    this.$root.$on('notificationPanelAdd', (item) => {
      this.notifications.push(item);
      setTimeout(() => {
        this.deleteItemNotification(item.ID);
      }, 5000);
    });
  },
  methods: {
    deleteItemNotification(itemID) {
      this.notifications = this.notifications.filter((x) => x.ID !== itemID);
    },
    onClickPanel(item) {
      this.$root.$emit('showPanelNotifications');
      this.deleteItemNotification(item.ID);
    },
  },
};
</script>

<style lang="scss">
.notification-panel-enter,
.notification-panel-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.notification-panel-leave-active {
  position: absolute;
}

.notification-panel {
  position: fixed;
  bottom: 100px;
  left: 40px;
  z-index: 900;
  &__item {
    transition: all 0.5s;
    background-color: #fff;
    &:first-child {
      margin-bottom: 0;
    }
    margin-top: 8px;
    width: 316px;

    padding: 12px 16px;
    border: 1px solid #19bf95;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 2px 2px 4px 0 rgba(61, 101, 192, 0.16);
    position: relative;
    &-content {
      display: flex;
    }
    &-icon {
      color: #19bf95;
      margin-right: 16px;
    }
    &-text {
      font-size: 14px;
      color: #333333;
      span {
        display: block;
        line-height: 16px;
        &:first-child {
          line-height: 22px;
          margin-bottom: 4px;
          font-weight: 700;
        }
      }
    }
    &-close {
      position: absolute;
      color: #d8e3eb;
      right: 8px;
      top: 8px;
      cursor: pointer;
      z-index: 100;
    }
  }
}
</style>
